import { Component, Inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormGroup,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";
import { CompanyService } from "../../services/company.service";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-cashback-settings",
  templateUrl: "./cashback-settings.component.html",
  styleUrls: ["./cashback-settings.component.scss"],
  imports: [CommonModule, ReactiveFormsModule],
})
export class CashbackSettingsComponent implements OnInit {
  form!: FormGroup;
  companyId = "";
  loaded = false;
  saving = false;

  constructor(
    @Inject(CompanyService) private companyService: CompanyService,
    @Inject(UserService) private userService: UserService,
    @Inject(UntypedFormBuilder) private fb: UntypedFormBuilder
  ) {}

  async ngOnInit() {
    this.createForm();
    await this.loadCompany();
  }

  private createForm(): void {
    this.form = this.fb.group({
      cashbackPercentual: [5, [Validators.required, Validators.min(0.1), Validators.max(100)]],
      limiteCompra: [200, [Validators.required, Validators.min(1)]],
    });
  }

  private async loadCompany(): Promise<void> {
    try {
      const userJson = localStorage.getItem("user");
      if (!userJson) return;

      const uid: string = JSON.parse(userJson)?.uid;
      if (!uid) return;

      const userRecord = await this.userService.getByUid(uid);
      if (!userRecord?.["companyId"]) return;

      this.companyId = userRecord["companyId"];
      const data = await this.companyService.getCompanyById(this.companyId);
      if (!data) return;

      this.form.patchValue({
        cashbackPercentual: data.cashbackPercentual ?? 5,
        limiteCompra: data.limiteCompra ?? 200,
      });
    } catch (error) {
      Swal.fire("Erro", "Não foi possível carregar as configurações.", "error");
    } finally {
      this.loaded = true;
    }
  }

  async onSubmit(): Promise<void> {
    if (this.form.invalid || !this.companyId) {
      Swal.fire("Atenção", "Preencha todos os campos corretamente.", "warning");
      return;
    }

    this.saving = true;
    try {
      await this.companyService.update(this.companyId, {
        cashbackPercentual: Number(this.form.value.cashbackPercentual),
        limiteCompra: Number(this.form.value.limiteCompra),
      });
      Swal.fire("Salvo!", "Configurações de cashback atualizadas.", "success");
    } catch (error) {
      Swal.fire("Erro", "Não foi possível salvar. Tente novamente.", "error");
    } finally {
      this.saving = false;
    }
  }
}
